import { render, staticRenderFns } from "./OrdersInboundTableMobile.vue?vue&type=template&id=00fe737d&scoped=true"
import script from "./OrdersInboundTableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersInboundTableMobile.vue?vue&type=script&lang=js"
import style0 from "./OrdersInboundTableMobile.vue?vue&type=style&index=0&id=00fe737d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe737d",
  null
  
)

export default component.exports